import React from 'react';

import { Step } from 'src/types';
import FormBuilderModalContent from 'src/views/shared/FormBuilderModalContent';

interface TaskTemplateBuilderModalProps {
  onClose: () => void,
  step: Step,
}

const TaskTemplateBuilderModal = ({
  onClose,
  step,
}: TaskTemplateBuilderModalProps) => {
  const { workflowId } = step;
  // @ts-ignore - task template cannot be null here
  const { perspectiveId } = step.action.taskTemplate;

  return (
    <FormBuilderModalContent
      onClose={onClose}
      workflowId={workflowId}
      perspectiveId={perspectiveId}
    />
  );
};

export default TaskTemplateBuilderModal;
